export const tile = {
    bgcolor: 'rgba(255,255,255,0.1)',
};

export const chip = {
    borderRadius: '999px',
    bgcolor: 'rgba(255,255,255,0.08)',
};

export const pill = {
    borderRadius: '999px',
    height: 22,
    bgcolor: 'rgba(255,255,255,0.08)',
};

export const button = {
    height: 40,
    borderRadius: '10px',
};
